import React from 'react';
import Page from './Page';
import ContactForm from './ContactForm';

const ContactPage = () => (
  <Page eyebrow="REACH OUT" title="Get in Touch">
    <p>
      We'd love to hear from you — whether you're a reader, an author, a
      publisher or a corporate partner.
    </p>
    <p>
      <strong>Email:</strong>{' '}
      <a href="mailto:hello@icraftz.com">hello@icraftz.com</a>
    </p>
    <div className="legal-divider" />
    <ContactForm source="contact" submitLabel="Send Message" />
  </Page>
);

export default ContactPage;
